.goldMobileFilters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;

  /* button itself has a margin-right of 16px */
  margin-right: -16px;
}

@media all and (--reefer-media-tablet-min) {
  .goldMobileFilters {
    display: none;
  }
}
